export const en = {
    groups: 'In ad groups',
    name: 'Name',
    preview: 'Preview'
};
